<template>
  <div class="quiz-question-renderer text-left">
    <QuizQuestionMultipleChoice
      v-if="questionType === 'MULTIPLE_CHOICE'"
      :question="question"
      :questionIndex="questionIndex"
      :questionCount="questionCount"
      :learningCardAssociationId="learningCardAssociationId"
      :isSurveyQuestion="isSurveyQuestion"
      :surveyClientId="surveyClientId"
      :whistleToken="whistleToken"
      :enteredEmail="enteredEmail"
      :context="context"
      :preview="preview"
      @next-question="$emit('next-question', $event)"
      @complete-quiz="$emit('complete-quiz', $event)"
    />
    <QuizQuestionSelectAll
      v-else-if="questionType === 'SELECT_ALL'"
      :question="question"
      :questionIndex="questionIndex"
      :questionCount="questionCount"
      :learningCardAssociationId="learningCardAssociationId"
      :isSurveyQuestion="isSurveyQuestion"
      :surveyClientId="surveyClientId"
      :whistleToken="whistleToken"
      :enteredEmail="enteredEmail"
      :context="context"
      :preview="preview"
      @next-question="$emit('next-question', $event)"
      @complete-quiz="$emit('complete-quiz', $event)"
    />
    <QuizQuestionScale
      v-else-if="questionType === 'SCALE'"
      :question="question"
      :questionIndex="questionIndex"
      :questionCount="questionCount"
      :learningCardAssociationId="learningCardAssociationId"
      :isSurveyQuestion="isSurveyQuestion"
      :surveyClientId="surveyClientId"
      :whistleToken="whistleToken"
      :enteredEmail="enteredEmail"
      :context="context"
      :preview="preview"
      @next-question="$emit('next-question', $event)"
      @complete-quiz="$emit('complete-quiz', $event)"
    />
    <QuizQuestionLikert
      v-else-if="questionType === 'LIKERT'"
      :question="question"
      :questionIndex="questionIndex"
      :questionCount="questionCount"
      :learningCardAssociationId="learningCardAssociationId"
      :isSurveyQuestion="isSurveyQuestion"
      :surveyClientId="surveyClientId"
      :whistleToken="whistleToken"
      :enteredEmail="enteredEmail"
      :context="context"
      :preview="preview"
      @next-question="$emit('next-question', $event)"
      @complete-quiz="$emit('complete-quiz', $event)"
    />
    <QuizQuestionShortAnswer
      v-else-if="questionType === 'SHORT_ANSWER'"
      :question="question"
      :questionIndex="questionIndex"
      :questionCount="questionCount"
      :learningCardAssociationId="learningCardAssociationId"
      :isSurveyQuestion="isSurveyQuestion"
      :surveyClientId="surveyClientId"
      :whistleToken="whistleToken"
      :enteredEmail="enteredEmail"
      :context="context"
      :preview="preview"
      @next-question="$emit('next-question', $event)"
      @complete-quiz="$emit('complete-quiz', $event)"
    />
    <p v-else class="quiz-question-renderer__unsupported">
      Unsupported question type: {{ questionType }}
    </p>
  </div>
</template>

<script>
import QuizQuestionMultipleChoice from "@/components/learning/QuizQuestion/QuizQuestionMultipleChoiceV2";
import QuizQuestionSelectAll from "@/components/learning/QuizQuestion/QuizQuestionSelectAllV2";
import QuizQuestionScale from "@/components/learning/QuizQuestion/QuizQuestionScaleV2";
import QuizQuestionLikert from "@/components/learning/QuizQuestion/QuizQuestionLikertV2";
import QuizQuestionShortAnswer from "@/components/learning/QuizQuestion/QuizQuestionShortAnswerV2";

export default {
  name: "QuizQuestionRenderer",
  components: {
    QuizQuestionMultipleChoice,
    QuizQuestionSelectAll,
    QuizQuestionScale,
    QuizQuestionLikert,
    QuizQuestionShortAnswer,
  },
  props: {
    /** The question object (from LearningQuizQuestions). */
    question: {
      type: Object,
      required: true,
    },
    questionIndex: {
      type: Number,
      required: true,
    },
    questionCount: {
      type: Number,
      required: true,
    },
    learningCardAssociationId: {
      type: Number,
      default: null,
    },
    isSurveyQuestion: {
      type: Boolean,
      default: false,
    },
    surveyClientId: {
      type: Number,
      default: null,
    },
    whistleToken: {
      type: String,
      default: null,
    },
    enteredEmail: {
      type: String,
      default: null,
    },
    context: {
      type: String,
      default: "survey",
    },
    preview: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    questionType() {
      return this.question ? this.question.type : null;
    },
  },
};
</script>

<style scoped>
.quiz-question-renderer {
  width: 100%;
}

.quiz-question-renderer__unsupported {
  color: rgba(0, 0, 0, 0.6);
  font-size: 14px;
  margin: 0;
}
</style>
